import { IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as QuickSaveIcon } from '@work4all/assets/icons/quick-save.svg';

import { Tooltip } from '@work4all/components/lib/components/tooltip/Tooltip';

interface QuickSaveButtonProps {
  isDirty: boolean;
  isSubmitting: boolean;
  isDisabled: boolean;
  onQuickSave: () => Promise<void>;
}

export const QuickSaveButton: React.FC<QuickSaveButtonProps> = ({
  isDirty,
  isSubmitting,
  isDisabled,
  onQuickSave,
}) => {
  const { t } = useTranslation();

  const disabled = !isDirty || isSubmitting || isDisabled;

  return (
    <Tooltip title={t('COMMON.QUICK_SAVE')}>
      <span>
        <IconButton
          color="primary"
          disabled={disabled}
          onClick={onQuickSave}
          sx={{ mr: 1 }}
        >
          <QuickSaveIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};
